<template>
    <div class="pro_container">
        <global-tag>
            <span slot="title">二维码管理</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="名称：">
                                <el-input
                                    v-model="username"
                                    placeholder="请输入名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="5">
              <el-form-item label="联系方式：">
                <el-input v-model="phone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="身份证号：">
                <el-input v-model="identity" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            </el-col> -->
                        <el-col :span="5" :offset="4">
                            <el-button
                                type="primary"
                                icon="el-icon-search"
                                @click="search"
                                >搜索</el-button
                            >
                            <el-button
                                type="info"
                                icon="el-icon-delete"
                                @click="clear"
                                >清除条件</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        @click="Reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox
                                    ><br />
                                    <el-checkbox label="名称"></el-checkbox
                                    ><br />
                                    <el-checkbox label="内容"></el-checkbox
                                    ><br />
                                    <el-checkbox label="添加人"></el-checkbox
                                    ><br />
                                    <el-checkbox label="添加时间"></el-checkbox
                                    ><br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    width="80"
                    type="index"
                    align="center"
                    label="序号"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="名称"
                    prop="name"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '名称'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="内容"
                    prop="content"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '内容'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="添加人"
                    prop="userName"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '添加人'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="添加时间"
                    prop="createDate"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '添加时间'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    align="center"
                    width="140px"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="生成二维码"
                            placement="top-start"
                        >
                            <el-popover
                                placement="top-start"
                                width="200"
                                trigger="click"
                            >
                                <slot>
                                    <vue-qr
                                        :text="vueQrText"
                                        :size="200"
                                    ></vue-qr>
                                </slot>
                                <img
                                    slot="reference"
                                    src="../assets/img/table_sc.png"
                                    style="
                                        width: 19px;
                                        margin-left: 12px;
                                        cursor: pointer;
                                    "
                                    @click="createCode(scope.row)"
                                />
                            </el-popover>
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                @click="deleteTable(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                @size-change="handletableSize"
                @current-change="handleTableChange"
            ></el-pagination>
        </div>
        <!-- tbale 新增删除修改弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="40%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    :model="formData"
                    ref="formData"
                    :rules="formDataRules"
                    :disabled="dialogVisibleTitle == '详情'"
                >
                    <el-form-item label="名称：" prop="name">
                        <el-input v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="内容：" prop="content">
                        <el-input
                            type="textarea"
                            v-model="formData.content"
                            :rows="5"
                        ></el-input>
                    </el-form-item>
                    <!-- 		  
		  <el-form-item label="组织机构：" style="height:40px">
		    <el-select style="width: 100%;"
		               class="marginT34"
		               v-model="formData.orgName"
		               placeholder="请选择组织机构"
		               ref="selectBoxRef"
		               >
		      <el-option :value="formData.orgName"
		                 style="height: auto;">
		        <el-tree :data="orgList"
		                 :props="defaultProps"
		  						 ref='tree'
		                 @node-click="handleEditNodeClick"
		                 class="tree_box"></el-tree>
		      </el-option>
		    </el-select>
		  </el-form-item> -->
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="handleSubmut"
                    v-show="dialogVisibleTitle != '详情'"
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import vueQr from "vue-qr"
import common from "../../../utils/common.js"
import globalTag from "../components/globalTag"
export default {
    name: "proManage",
    data() {
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgLevels: "",
            orgList: [],
            arrOrgList: [],
            username: "", //姓名
            phone: "", //联系方式
            identity: "", //身份证号
            tableData: [
                // tabble数据
            ],
            tempTableChekbox: [
                "序号",
                "名称",
                "内容",
                "添加人",
                "添加时间",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "名称",
                "内容",
                "添加人",
                "添加时间",
                "操作",
            ],
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            formData: {
                //table表单
                name: "", //姓名
                content: "", //内容
                orgName: "", //内容
                shengjiId: "",
                shijiId: "",
                qujiId: "",
                stationId: "",
                shequjiId: "",
            },
            formDataRules: {
                //table表单
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                ], //姓名
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ], //内容
                orgName: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "change",
                    },
                ], //内容
            },
            vueQrText: "",
            pageSize: 10,
            pageNo: 1,
            total: 0,
        }
    },
    components: {
        globalTag,
        vueQr,
    },
    created() {
        this.getOrg()
        this.getcodeTableData()
    },
    inject: ["reload"], //注入
    methods: {
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            // this.arrOrgList = arr

            console.log(this.arrOrgList, 111111111)
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            this.$set(this.formData, "orgId", data.orgId)
            this.$set(this.formData, "parentId", data.parentId)
            this.$set(this.formData, "orgType", data.orgType)
            this.$set(this.formData, "orgName", data.label)

            this.$set(this.formData, "qujiId", obj.qujiId)
            this.$set(this.formData, "shengjiId", obj.shengjiId)
            this.$set(this.formData, "shijiId", obj.shijiId)
            this.$set(this.formData, "stationId", obj.stationId)
            this.$set(this.formData, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {isValid: 1,},
                })
                .then((res) => {
                    if (res.code == 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                            this.orgLevels = res.content[0].orgLevel
                        }
                    }
                })
        },
        search() {
            this.getcodeTableData()
        },
        clear() {
            this.pageSize = 10
            this.pageNo = 1
            this.username = ""
            this.getcodeTableData()
        },
        //删除二维码列表
        deleteTable(row) {
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/jjyl/admin/qRCodeManage/info/deleteById",
                            method: "POST",
                            data: {
                                id: row.id,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("删除成功")
                                this.getcodeTableData()
                            } else {
                                this.$message.error("删除失败")
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //获取二维码table列表
        getcodeTableData() {
            this.$http
                .request({
                    url: "/jjyl/admin/qRCodeManage/info/findList",
                    method: "POST",
                    data: {
                        pageSize: this.pageSize,
                        pageNo: this.pageNo,
                        name: this.username,
                        qujiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .qujiId,
                        shengjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shengjiId,
                        shijiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .shijiId,
                        stationId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).stationId,
                        shequjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shequjiId,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        //新增二维码记录
        handleSubmut() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.$http
                        .request({
                            url: "/jjyl/admin/qRCodeManage/info/insertOrUpdate",
                            method: "POST",
                            data: {
                                name: this.formData.name,
                                content: this.formData.content,
                                createId: this.$store.state.info.id,
                                userName: this.$store.state.info.name,
                                orgId: this.formData.orgId,
                                orgName: this.formData.orgName,
                                orgType: this.formData.orgType,
                                parentId: this.formData.parentId,
                                // qujiId: this.formData.qujiId,
                                // shengjiId: this.formData.shengjiId,
                                // shijiId: this.formData.shijiId,
                                // stationId: this.formData.stationId,
                                // shequjiId: this.formData.shequjiId,
                                qujiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).qujiId,
                                shengjiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shengjiId,
                                shijiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shijiId,
                                stationId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).stationId,
                                shequjiId: JSON.parse(
                                    localStorage.getItem("czUserInfo")
                                ).shequjiId,
                                // qujiId:JSON.parse(localStorage.getItem('czUserInfo')).qujiId,
                                // shengjiId:JSON.parse(localStorage.getItem('czUserInfo')).shengjiId,
                                // shijiId:JSON.parse(localStorage.getItem('czUserInfo')).shijiId,
                                // stationId:JSON.parse(localStorage.getItem('czUserInfo')).stationId,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("保存成功")
                                this.getcodeTableData()
                            } else {
                                this.$message.error("保存失败")
                            }
                            this.dialogVisible = false
                        })
                } else {
                    console.log("error submit!!")
                }
            })
        },
        //列表pagesize发生改变
        handletableSize(val) {
            this.pageSize = val
            this.getcodeTableData()
        },
        //列表页码发生改变
        handleTableChange(val) {
            this.pageNo = val
            this.getcodeTableData()
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        handleTableForm(title, row) {
            //处理table表格表单
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            if (title == "详情") {
                this.formData.name = row.name
                this.formData.content = row.content
                this.formData.orgName = row.orgName
            }
        },
        dialogVisibleClone() {
            //table表格表单弹窗关闭时事件
            this.formData.name = ""
            this.formData.content = ""
        },
        createCode(row) {
            //生成二维码
            this.vueQrText = row.content
        },
    },
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}
</style>